export default "__VITE_ASSET__D_VrwsBv__"